/* eslint-disable @typescript-eslint/no-implied-eval */
import { SignTitle } from '@/components'
import { Button, Select, Tooltip } from 'antd'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useGetDomain } from '../target/utils'
import { useContactsAuto, usePostContactsAuto } from './utils'
import { useGetAuthorizeConfig } from '@/pages/account-center/authorize-manage/utils'
import { t } from '@/i18n'
interface HeaderProps {
  exportClick: () => void
  idsLength: number
  refresh: () => void
}

const Header: React.FC<HeaderProps> = props => {
  const { exportClick, idsLength, refresh } = props
  const [getDomain, targetDomain] = useGetDomain()
  const [getTime, time, flag, cancel] = useContactsAuto()
  const [postContactsAuto, loading] = usePostContactsAuto()
  const [authorizeConfig, runAuthorizeConfig] = useGetAuthorizeConfig()

  let [domainId, setDomainId] = useState()
  useEffect(() => {
    if (targetDomain.length > 0) {
      setDomainId(targetDomain[0]?.id)
      getTime({ domain_id: targetDomain[0]?.id })
        .then(() => {})
        .catch(err => {})
    }
  }, [targetDomain])

  useEffect(() => {
    if (flag === 2) {
      refresh()
    }
  }, [flag])

  useEffect(() => {
    runAuthorizeConfig().catch(_ => {})
  }, [])

  return (
    <TitleContainer>
      <SignTitle style={{ width: 364, display: 'flex', alignItems: 'center' }}>
        <span style={{ marginRight: 8 }}>{t('邮箱列表')}</span>
        <Text>
          {t('最近更新时间：')}
          {time || '-'}
        </Text>
      </SignTitle>
      <Container>
        <Button
          type="primary"
          disabled={idsLength === 0}
          style={{ marginRight: 8 }}
          onClick={exportClick}
        >
          {t('导出数据')}
        </Button>
        <ButtonContainer>
          <Tooltip
            title={
              authorizeConfig?.emailAuthTotal - authorizeConfig?.emailAuthUsed <= 0
                ? t('请提升验证邮箱授权数量')
                : ''
            }
          >
            <CollectButton
              onClick={() => {
                postContactsAuto({ domain_id: domainId })
                  .then(() => {
                    getTime({ domain_id: domainId })
                      .then(() => {})
                      .catch(err => {})
                  })
                  .catch(err => {})
              }}
              type="primary"
              disabled={
                authorizeConfig?.emailAuthTotal - authorizeConfig?.emailAuthUsed <= 0
                  ? true
                  : new Date().getTime() - new Date(time).getTime() < 86400000
              }
              loading={flag === 1}
            >
              {t('收集邮件账号')}
            </CollectButton>
          </Tooltip>
          <CollectSelect
            getPopupContainer={() => document.body}
            placement={'bottomRight'}
            key={targetDomain[0]?.id}
            disabled={flag === 1}
            defaultValue={targetDomain[0]?.id}
            onChange={value => {
              setDomainId((domainId = value))
              getTime({ domain_id: value })
                .then(() => {})
                .catch(err => {})
            }}
            style={{ width: 140 }}
          >
            {targetDomain?.map(item => (
              <Select.Option key={item?.id} value={item?.id}>
                {item?.domain}
              </Select.Option>
            ))}
          </CollectSelect>
        </ButtonContainer>
      </Container>
    </TitleContainer>
  )
}

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
`

const Container = styled.div`
  display: flex;
  align-items: flex-end;
`

const Text = styled.div`
  font-size: 12px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #666;
  padding-right: 8px;
`

const ButtonContainer = styled.div`
  display: flex;
`

const CollectButton = styled(Button)`
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: 0;
  display: flex;
  flex-direction: row-reverse;
  .ant-btn-loading-icon .anticon {
    padding: 0 0 0 8px;
  }
`

const CollectSelect = styled(Select)`
  .ant-select-selector {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
`

export default Header
